import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero-section text-white d-flex align-items-center justify-content-center" }


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroSection',
  setup(__props) {

// This component is purely visual, no JavaScript needed here.

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "hero-content text-center" }, [
      _createElementVNode("h1", { class: "display-3 fw-bold" }, "Bienvenue chez Bébé Bulle"),
      _createElementVNode("p", { class: "lead my-4" }, " Un lieu chaleureux et sécurisant où chaque enfant peut s'épanouir à son rythme. "),
      _createElementVNode("a", {
        href: "#formulaire",
        class: "btn btn-primary btn-lg"
      }, " Faire une pré-inscription ")
    ], -1)
  ])))
}
}

})